import request from "@/utils/request";

// 登录
export async function setLoginRe(params) {
    return request("/dtk_go_app_api/v1/login-re", {
      method: "POST",
      data: params
    });
}
export async function getSendMsgNew(params) {
    return request("/dtk_go_app_api/v1/send-msg-new", {
      method: "GET",
      data: params
    });
} 

export async function getAddTop(params) {
    return request("/dtk_go_app_api/v1/add-top", {
      method: "GET",
      data: params
    });
} 






// WEBPACK FOOTER //
// ./src/services/index.js